import { useEffect, useState } from 'preact/hooks';

export type ColorScheme = 'dark' | 'light';

function getColorScheme(): ColorScheme {
  const htmlScheme = document.documentElement.dataset.colorScheme;

  if (htmlScheme) {
    return htmlScheme === 'dark' ? 'dark' : 'light';
  }

  const storybookChild = document
    .getElementById('storybook-root')
    ?.querySelector<HTMLElement>('[data-color-scheme]');

  if (storybookChild?.dataset.colorScheme) {
    return storybookChild.dataset.colorScheme === 'dark' ? 'dark' : 'light';
  }

  return 'light';
}

export function useColorScheme(): ColorScheme {
  const [mode, setMode] = useState<ColorScheme>(getColorScheme);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setMode(getColorScheme());
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-color-scheme'],
    });

    return () => observer.disconnect();
  }, []);

  return mode;
}
